// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-wrapper {
  width: 100%;
  margin-top: 80px;
  display: flex;
  align-items: flex-end;
}

.job-eligible-text {
  text-align: right;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.job-eligible-count {
  font-weight: 500;
  font-size: 28px;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.avatar-button {
  min-width: 64px !important;
  width: 64px !important;
  height: 64px !important;
  background: #EEEEEE !important;
  color: #888888 !important;
  font-size: 22.4px !important;
  padding: 6.4px 12.8px !important;
}

.dev-profile-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.job-name-div {
  text-align: left;
  color: #212121 !important;
  opacity: 1;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: -0.5px;
}

.job-role-div {
  text-align: left;
  color: #888888 !important;
  opacity: 1;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.passed-test-div {
  margin-top: 16px
}

.test-passed-card .ant-card-body {
  padding: 0;
  /* height: 32px; */
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 12px;
  opacity: 1;
}

.test-passed-card.ant-card-bordered {
   border: 1px solid #CCCCCC;
  border-radius: 4px;
}

.test-passed-text {
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
  color: #444444;
  opacity: 1;
}

.test-passed-title {
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}

.UserInfoComponent {
  background-color: transparent !important;
  border: none !important;
  padding: 0;
  max-width: 964px;
}

.user-info-wrapper {
  margin: 0;
}

@media only screen and (max-width: 480px) {
  .user-info-wrapper {
    zoom: 0.6;
    font-weight: 500;
  }
}

.UserInfoComponent > .ant-card-body {
  padding: 0 !important;
}

.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper {
  margin-left: 24px;
  padding-top: 6px;
  height: 64px;
  display: flex;
  flex-direction: column;
}

.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .name-job-count {
  height: 26px;
  display: flex;
  align-items: flex-end;
}

.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .stack-summary {
  margin-top: 8px;
  display: flex;
  align-items: flex-end;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper {
  margin-top: 24px;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements {
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 64px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 0 12px #0000000A;
  border-radius: 8px;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span {
  font-size: 16px;
  color: #212121;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span:nth-child(2) {
  margin-left: 8px;
  font-size: 14px;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci > div:first-of-type {
  font-weight: 500;
  font-size: 20px;
  color: #212121;
  letter-spacing: 0;
}

.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci > div {

  font-size: 14px;
  color: #888888;
  letter-spacing: 0;
  margin-top: 16px;
}
.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci .skills {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #888888;
  letter-spacing: 0;
  margin-top: 24px;
}
.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci .show-me-how {
  font-size: 14px;
  color: #888888;
  letter-spacing: 0;
  margin-top: 34px;
  display: flex;
  align-items: center;
}


.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci {
  padding: 32px 40px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0 0 24px #0000000A;
  border-radius: 8px;
}

.UserInfoComponent a {
  font-weight: 500;
}

.ant-checkbox-group-item {
  display: block !important;
  margin-right: 0 !important;
}

.ant-checkbox {
  width: 20px !important;
  height: 30px !important;
}

.ant-checkbox .ant-checkbox-inner {
  top: 5px !important;
  left: 0 !important;
}

.ant-checkbox-wrapper + span, .ant-checkbox + span {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
}

@media (min-width: 350px) and (max-width: 1024px) {
  .job-name-div {
    line-height: unset;
  }

  .UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .name-job-count {
    height: unset;
  }

  .UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper {
    height: unset;
  }

  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    height: unset;
  }

  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span {
    font-size: 20px;
  }

  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span:nth-child(2) {
    margin: unset;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/JobPageUserInfoComponent/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;GACG,yBAAyB;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,+CAA+C;EAC/C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":[".user-info-wrapper {\n  width: 100%;\n  margin-top: 80px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.job-eligible-text {\n  text-align: right;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.job-eligible-count {\n  font-weight: 500;\n  font-size: 28px;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.avatar-button {\n  min-width: 64px !important;\n  width: 64px !important;\n  height: 64px !important;\n  background: #EEEEEE !important;\n  color: #888888 !important;\n  font-size: 22.4px !important;\n  padding: 6.4px 12.8px !important;\n}\n\n.dev-profile-image {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n\n.job-name-div {\n  text-align: left;\n  color: #212121 !important;\n  opacity: 1;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n}\n\n.job-role-div {\n  text-align: left;\n  color: #888888 !important;\n  opacity: 1;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n}\n\n.passed-test-div {\n  margin-top: 16px\n}\n\n.test-passed-card .ant-card-body {\n  padding: 0;\n  /* height: 32px; */\n  padding-top: 4px;\n  padding-bottom: 4px;\n  padding-left: 8px;\n  padding-right: 12px;\n  opacity: 1;\n}\n\n.test-passed-card.ant-card-bordered {\n   border: 1px solid #CCCCCC;\n  border-radius: 4px;\n}\n\n.test-passed-text {\n  text-align: left;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #444444;\n  opacity: 1;\n}\n\n.test-passed-title {\n  text-align: left;\n  font-size: 14px;\n  line-height: 22px;\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n\n.UserInfoComponent {\n  background-color: transparent !important;\n  border: none !important;\n  padding: 0;\n  max-width: 964px;\n}\n\n.user-info-wrapper {\n  margin: 0;\n}\n\n@media only screen and (max-width: 480px) {\n  .user-info-wrapper {\n    zoom: 0.6;\n    font-weight: 500;\n  }\n}\n\n.UserInfoComponent > .ant-card-body {\n  padding: 0 !important;\n}\n\n.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper {\n  margin-left: 24px;\n  padding-top: 6px;\n  height: 64px;\n  display: flex;\n  flex-direction: column;\n}\n\n.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .name-job-count {\n  height: 26px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .stack-summary {\n  margin-top: 8px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper {\n  margin-top: 24px;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements {\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  height: 64px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 0 12px #0000000A;\n  border-radius: 8px;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span {\n  font-size: 16px;\n  color: #212121;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span:nth-child(2) {\n  margin-left: 8px;\n  font-size: 14px;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci > div:first-of-type {\n  font-weight: 500;\n  font-size: 20px;\n  color: #212121;\n  letter-spacing: 0;\n}\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci > div {\n\n  font-size: 14px;\n  color: #888888;\n  letter-spacing: 0;\n  margin-top: 16px;\n}\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci .skills {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 14px;\n  color: #888888;\n  letter-spacing: 0;\n  margin-top: 24px;\n}\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci .show-me-how {\n  font-size: 14px;\n  color: #888888;\n  letter-spacing: 0;\n  margin-top: 34px;\n  display: flex;\n  align-items: center;\n}\n\n\n.UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-almost-ready-lci {\n  padding: 32px 40px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0 0 24px #0000000A;\n  border-radius: 8px;\n}\n\n.UserInfoComponent a {\n  font-weight: 500;\n}\n\n.ant-checkbox-group-item {\n  display: block !important;\n  margin-right: 0 !important;\n}\n\n.ant-checkbox {\n  width: 20px !important;\n  height: 30px !important;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  top: 5px !important;\n  left: 0 !important;\n}\n\n.ant-checkbox-wrapper + span, .ant-checkbox + span {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n}\n\n@media (min-width: 350px) and (max-width: 1024px) {\n  .job-name-div {\n    line-height: unset;\n  }\n\n  .UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper .name-job-count {\n    height: unset;\n  }\n\n  .UserInfoComponent .user-info-wrapper .name-stack-summary-wrapper {\n    height: unset;\n  }\n\n  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 24px;\n    height: unset;\n  }\n\n  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span {\n    font-size: 20px;\n  }\n\n  .UserInfoComponent .user-info-wrapper .next-steps-wrapper .next-steps-meet-requirements > span:nth-child(2) {\n    margin: unset;\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
